//inspired by https://angular.dev/ecosystem/service-workers/communications
import { ApplicationRef, inject, Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { concat, first, interval, Observable, Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  
  private _updateAvailable = new Subject<void>();
  updateAvailable$: Observable<void> = this._updateAvailable.asObservable();

  constructor(private updates: SwUpdate, private appRef: ApplicationRef) {
    this.handleEvents();
    this.checkForUpdates();
  }

  checkForUpdates() {
    if(!this.updates.isEnabled) return;
    concat(
      this.appRef.isStable.pipe(first(stable => stable === true)), //wait for app to get stable
      interval(60 * 60 * 1000) //check every 1 hour
    ).subscribe(async () => {
      try {
        const updateFound = await this.updates.checkForUpdate();
        console.log(updateFound ? 'A new version is available.' : 'Already on the latest version.');
      } catch (err) {
        console.error('Failed to check for updates:', err);
      }

    });
  }

  async refreshApp() {
    if (this.updates.isEnabled) {
      try {
        const updateFound = await this.updates.checkForUpdate();
        if (updateFound) await this.updates.activateUpdate();
      } catch (err) {
        console.error('Failed to activate the latest app version:', err);
      }
    }
    location.reload();
  }

  private handleEvents() {
    this.updates.versionUpdates.subscribe(event => {
      switch (event.type) {
        case "VERSION_DETECTED":
          console.log(`Downloading new app version: ${event.version.hash}`);
          break;
        case "VERSION_INSTALLATION_FAILED":
          console.error(`Failed to install new app version: ${event.version.hash}`);
          break;
        case "VERSION_READY":
          console.log(`New app version downloaded: ${event.currentVersion.hash} -> ${event.latestVersion.hash}`);
          this._updateAvailable.next();
          break;
      }

    });
  }

  test() {
    this._updateAvailable.next();
  }

}
